import { atom } from 'jotai'

export type CompletionStepStatus = 'pending' | 'active' | 'done' | 'error' | 'skipped'

export type CompletionStepId = 'save' | 'check' | 'authorise' | 'submit'

export type CompletionStep = {
	id: CompletionStepId
	status: CompletionStepStatus
	/** Issue/error messages to show under the step when it fails. */
	messages?: string[]
}

export const COMPLETION_STEP_ORDER: CompletionStepId[] = ['save', 'check', 'authorise', 'submit']

export function initialCompletionSteps(): CompletionStep[] {
	return COMPLETION_STEP_ORDER.map((id) => ({ id, status: 'pending' as const }))
}

export const completionStepsAtom = atom<CompletionStep[]>(initialCompletionSteps())

/** True when any step has failed — used to switch the popup into its error layout. */
export const completionHasErrorAtom = atom((get) => get(completionStepsAtom).some((step) => step.status === 'error'))
